const styles = {
  statusCodeItem: {
    '&.MuiMenuItem-root.MuiButtonBase-root': {
      p: 1,
      '&.Mui-selected': {
        color: 'inherit',
      },
    },
    '&:hover': {
      '& .MuiCheckbox-root': {
        color: theme => theme.palette.primary.main,
      },
    },
    '& .MuiFormControlLabel-root': {
      alignItems: 'center',
      mr: 0,
    },
    '& .MuiCheckbox-root': {
      mr: 1.5,
    },
  },
  separator: {
    borderTop: theme => `1px solid ${theme.palette.neutral.lighter}`,
    color: theme => theme.palette.neutral.light,
    fontWeight: 600,
    paddingLeft: theme => theme.spacing(1.75),
    paddingTop: theme => theme.spacing(1),
    paddingBottom: theme => theme.spacing(0.5),
  },
}

export default styles
